import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "user-info-form" }
const _hoisted_2 = { class: "overflow-hidden sm:rounded-md" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "grid grid-cols-6 gap-6" }
const _hoisted_5 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "first-name",
  class: "onboarding-label"
}, "First Name", -1)
const _hoisted_7 = { class: "error-msg" }
const _hoisted_8 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "last-name",
  class: "onboarding-label"
}, "Last Name", -1)
const _hoisted_10 = { class: "error-msg" }
const _hoisted_11 = { class: "col-span-6 sm:col-span-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  for: "email-address",
  class: "onboarding-label"
}, "Email", -1)
const _hoisted_13 = { class: "error-msg" }
const _hoisted_14 = {
  key: 0,
  class: "col-span-6 sm:col-span-3"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "onboarding-label"
}, "Password", -1)
const _hoisted_16 = { class: "error-msg" }
const _hoisted_17 = {
  key: 1,
  class: "col-span-6 sm:col-span-3"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  for: "confirm-password",
  class: "onboarding-label"
}, "Confirm Password", -1)
const _hoisted_19 = { class: "error-msg" }
const _hoisted_20 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_21 = { class: "flex flex-row mt-4 items-baseline" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReCaptchaV2 = _resolveComponent("ReCaptchaV2")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LoadingButton = _resolveComponent("LoadingButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.userInfoSubmitted && _ctx.userInfoSubmitted(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "first-name",
                id: "first-name",
                autocomplete: "given-name",
                class: "text-input",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.firstName.$model) = $event))
              }, null, 512), [
                [_vModelText, _ctx.v$.firstName.$model]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.firstName.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "last-name",
                id: "last-name",
                autocomplete: "family-name",
                class: "text-input",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.lastName.$model) = $event))
              }, null, 512), [
                [_vModelText, _ctx.v$.lastName.$model]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.lastName.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _withDirectives(_createElementVNode("input", {
                type: "email",
                name: "email-address",
                id: "email-address",
                autocomplete: "email",
                class: "text-input",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.email.$model) = $event))
              }, null, 512), [
                [_vModelText, _ctx.v$.email.$model]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.email.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ]),
            (!_ctx.isUpdate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _hoisted_15,
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    name: "password",
                    id: "new-password",
                    autocomplete: "new-password",
                    class: "text-input",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.password.$model) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.v$.password.$model]
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.password.$errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "input-errors",
                      key: error.$uid
                    }, [
                      _createElementVNode("div", _hoisted_16, _toDisplayString(error.$message), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isUpdate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _hoisted_18,
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    name: "confirm-password",
                    id: "confirm-password",
                    autocomplete: "new-password",
                    class: "text-input",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.v$.confirmPw.$model) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.v$.confirmPw.$model]
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.confirmPw.$errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "input-errors",
                      key: error.$uid
                    }, [
                      _createElementVNode("div", _hoisted_19, _toDisplayString(error.$message), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _withDirectives(_createVNode(_component_ReCaptchaV2, { onToken: _ctx.tokenReceived }, null, 8, ["onToken"]), [
              [_vShow, _ctx.captchaRequired]
            ])
          ]),
          (_ctx.responseError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.responseError), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_21, [
          (!_ctx.isUpdate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createVNode(_component_router_link, { to: "/login" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Already have an account?")
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _hoisted_23,
          _createElementVNode("div", null, [
            _createVNode(_component_LoadingButton, {
              disabled: _ctx.v$.$invalid,
              loading: _ctx.loading
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.isUpdate ? 'Save' : 'Get Started'), 1)
              ]),
              _: 1
            }, 8, ["disabled", "loading"])
          ])
        ])
      ])
    ], 32)
  ]))
}